<div class="d-flex justify-content-between">
  <app-breadcrumb id="MainActivity" *ngIf="qualityService.refereshBreadCrumb"></app-breadcrumb>
  <div class="d-flex gap-4 align-items-center">
    <div class="">
      <span class="crDetail-status1" *ngIf="auDetailData != undefined"
        [ngStyle]="statusAppearance(auDetailData.status)">
        Status&nbsp;:&nbsp; <span>{{ this.auDetailData.status }}</span>
      </span>
    </div>
    <div class="d-flex gap-2">
      <div class="d-flex align-items-center justify-content-center communication_cta pointer"
        (click)="openExportPopup()" (keydown.enter)="openExportPopup()" matTooltip="Report">
        <img src="../../../assets/img/cr_module/pdf.svg" width="11px" height="15px" alt="" />
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta  pointer"
        matTooltip="Dependent of">
        <img src="../../../assets/img/qms_img/dependency.svg" width="14px" height="14px" alt=""
          (click)="openDependentsPopup()" (keydown.enter)="openDependentsPopup()" />
      </div>
      <div *ngIf="this.message.isTopicAdministrator">
        <div class="d-flex align-items-center justify-content-center communication_cta pointer"
          matTooltip="Communication">
          <img src="../../../assets/img/cr_module/communication.svg" width="14px" height="14px" alt=""
            (click)="openTopicPopup()" (keydown.enter)="openTopicPopup()" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta communication-icon pointer"
        matTooltip="Tag to Home" (click)="openTag()" (keydown.enter)="openTag()">
        <img src="../../../assets/img/tags.png" width="17px" height="19px" alt="" />
      </div>
    </div>
  </div>
</div>

<div class="page-loading-shade" *ngIf="isProcessing">
  <div class="loader_block">
    <span class="loader_dots"></span>
    <span class="loader_dots"></span>
    <span class="loader_dots"></span>
  </div>
</div>

<div class="d-flex justify-content-between mt-2 mb-2">
  <div class="" style="margin-right:auto;">
    <app-task-stage-statistics *ngIf="qualityService.refereshBreadCrumb"></app-task-stage-statistics>
  </div>

  <div class="" style="margin-right:1%;align-content:center;"
    *ngIf="(qualityService.activity.status == 'Findings In Progress' || qualityService.activity.status == 'Auditee Requested More Info.')  && parallelWorkflowList.length == 0 && auService.isAuditor">
    <div matTooltip="Add Workflow" class="d-flex justify-content-center align-items-center actions_cta pointer"
      style="border: 0.75px solid rgba(222, 235, 254, 0.8980392157); border-radius: 100px; width: 36px; height: 36px;"
      (click)="openAddWorkflow()" (keydown.enter)="openAddWorkflow()">
      <a>
        <img title="Switch User" src="..//..//../assets/img/parallel workflow.svg" alt="parallel-workflow" width="20"
          height="20">
      </a>
    </div>
  </div>

  <div class="">
    <div class="">
      <app-activity-dynamic-button></app-activity-dynamic-button>
    </div>
  </div>
</div>

<mat-tab-group mat-stretch-tabs class="activitytab1 mat-tab-container mat-elevation-z4" animationDuration="0ms"
  (selectedTabChange)="onTabClick($event)" [(selectedIndex)]="selectedTabIndex" #tabsGroup *ngIf="!isProcessing">
  <mat-tab label="Audit">
    <ng-template mat-tab-label>
      <span>
        <i class='fa-solid fa-file-pen' style="font-size: 18px;" aria-hidden="true"></i>
      </span>&nbsp;<span>{{qualityService.moduleFullName}}&nbsp;Details</span>
    </ng-template>
    <div class="row" style="margin: 5px;" *ngIf="dynamicLabel">
      <div class="row">
        <div class="col-md-3" *ngIf="auDetailData.scheduleNo">
          <div><label for="email ">{{dynamicLabel['PLAN_CREATED_FROM'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['PLAN_CREATED_FROM']?.fieldNotes"
              [matTooltip]="dynamicLabel['PLAN_CREATED_FROM']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-12" style="position: relative;">
              <input id="schedule-no" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auDetailData.scheduleNo" [disabled]="true">
            </div>
          </div>
        </div>

        <div class="col-md-3" *ngIf="auDetailData.auId">
          <div><label for="email ">{{dynamicLabel['AU_ID'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['AU_ID']?.fieldNotes"
              [matTooltip]="dynamicLabel['AU_ID']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-12" style="position: relative;">
              <input id="au-id" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auDetailData.auId" [disabled]="true">
            </div>
          </div>
        </div>

        <div class="col-md-3" *ngIf="auDetailData.parentPlanAuditNo">
          <div><label for="email ">{{dynamicLabel['PARENT_PLAN_AU_ID'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['PARENT_PLAN_AU_ID']?.fieldNotes"
              [matTooltip]="dynamicLabel['PARENT_PLAN_AU_ID']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-12" style="position: relative;">
              <input id="au-parent-id" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auDetailData.parentPlanAuditId" [disabled]="true">
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['ANNUAL_REF_NO'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['ANNUAL_REF_NO']?.fieldNotes"
              [matTooltip]="dynamicLabel['ANNUAL_REF_NO']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" *ngIf="!showAuRefNoAsTextBox" [(ngModel)]="selectedAuRefNo"
            (closed)="auRefNoTxt=''" (click)="focusSearch('auRefNoSearch')"
            (keydown.enter)="focusSearch('auRefNoSearch')"
            [ngClass]="{'odd-item-mat-select':isAuMasterOdd==selectedAuMaster}" [disabled]="freezePermanently">
            <input type="search" id="auRefNoSearch" class="dropdownsearchstyle" [(ngModel)]="auRefNoTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auRefNoDropDown| assessmentSearch :auRefNoTxt" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <input class="input-filed-continers" *ngIf="showAuRefNoAsTextBox" type="text"
            [(ngModel)]="auDetailData.annualRefNo" [disabled]="freezePermanently">
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['AUDIT_CATEGORY'].fieldName}}<span
                class="mandatory-symbol">*</span></label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_CATEGORY']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_CATEGORY']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuditCategory" (closed)="auditCategoryTxt=''"
            (click)="focusSearch('auditCategorySearch')" (keydown.enter)="focusSearch('auditCategorySearch')"
            [ngClass]="{'odd-item-mat-select':isAuditCategoryOdd==selectedAuditCategory}"
            [disabled]="freezePermanently">
            <input type="search" id="auditCategorySearch" class="dropdownsearchstyle" [(ngModel)]="auditCategoryTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auditCategoryDropDown| assessmentSearch :auditCategoryTxt"
              (onSelectionChange)="onAuditCategorySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['AUDIT_CLASSIFICATION'].fieldName}}<span
                class="mandatory-symbol">*</span></label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_CLASSIFICATION']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_CLASSIFICATION']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuditClassification"
            (closed)="auditClassificationTxt=''" (click)="focusSearch('auditClassificationSearch')"
            (keydown.enter)="focusSearch('auditClassificationSearch')"
            [ngClass]="{'odd-item-mat-select':isAuditClassificationOdd==selectedAuditClassification}"
            [disabled]="freezePermanently">
            <input type="search" id="auditClassificationSearch" class="dropdownsearchstyle"
              [(ngModel)]="auditClassificationTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auditClassificationDropDown| assessmentSearch :auditClassificationTxt"
              (onSelectionChange)="onClassificationSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['AUDIT_TYPE'].fieldName}}<span class="mandatory-symbol">*</span></label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_TYPE']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_TYPE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuditType" (closed)="auditTypeTxt=''"
            (click)="focusSearch('auMasterSearch')" (keydown.enter)="focusSearch('auMasterSearch')"
            [disabled]="selectedAuditCategory== null || freezeAuditTypeDropDown ||freezePermanently"
            [ngClass]="{'odd-item-mat-select':isAuditTypeOdd==selectedAuditType}">
            <input type="search" id="auMasterSearch" class="dropdownsearchstyle" [(ngModel)]="auditTypeTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of auditTypeDropDown| assessmentSearch :auditTypeTxt"
              (onSelectionChange)="onAuditTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" *ngIf="displayVendor">
          <div><label for="email ">{{dynamicLabel['VENDOR_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['VENDOR_NAME']?.fieldNotes"
              [matTooltip]="dynamicLabel['VENDOR_NAME']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input id="vendor-name" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auDetailData.vendorName" [disabled]="true">
            </div>
            <div class="col-sm-1" [hidden]="freezePermanently"
              style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
              (click)="openVendorPopup()" (keydown)="openVendorPopup()">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3" [hidden]="!displayDepartment">
          <div><label for="email ">{{dynamicLabel['DEPT_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME']?.fieldNotes"
              [matTooltip]="dynamicLabel['DEPT_NAME']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input id="d-name" class="input-filed-continers 1" type="text" style="cursor: not-allowed;"
                [(ngModel)]="auDetailData.departmentName" [disabled]="true">
            </div>
            <div class="col-sm-1" [hidden]="freezePermanently"
              style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
              (click)="openDepartmentPopup()" (keydown.enter)="openDepartmentPopup()">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3" *ngIf="displayFunctionalAreaOrServices">
          <div>
            <label for="email">{{dynamicLabel['FUNCTIONAL_AREA_OR_SERVICES'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['FUNCTIONAL_AREA_OR_SERVICES']?.fieldNotes"
              [matTooltip]="dynamicLabel['FUNCTIONAL_AREA_OR_SERVICES']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select multiple matInput #functionalAreaOrServices placeholder="Select"
            [(ngModel)]="selectedFunctionalAreaOrServices" (closed)="functionalAreaOrServicesTxt=''"
            (click)="focusSearch('functionalAreaOrServicesSearch')"
            (keydown.enter)="focusSearch('functionalAreaOrServicesSearch')"
            [ngClass]="{'odd-item-mat-select':isFunctionalAreaOrServicesOdd==selectedFunctionalAreaOrServices}"
            [disabled]="freezePermanently">
            <input type="search" id="functionalAreaOrServicesSearch" class="dropdownsearchstyle"
              [(ngModel)]="functionalAreaOrServicesTxt" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="functionalAreaOrServicesSelected"
                (change)="toggleAllSelection('functionalAreaOrServices')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item of functionalAreaOrServicesDropDown| assessmentSearch :functionalAreaOrServicesTxt"
              [value]="item.valueExp" (onSelectionChange)="onFunctionalAreaSelect($event, item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <ng-container *ngIf="dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y'">
          <div class="col-md-3">
            <div>
              <label id="requested-at" for="email">
                {{dynamicLabel['REQUESTED_AT']?.fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <mat-select matInput placeholder="Select" [(ngModel)]="auDetailData.requestedAt"
              (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested-at')"
              (keydown.enter)="focusSearch('focus-requested-at')" [disabled]="isFrozen"
              [ngClass]="{'odd-item-mat-select': isRequestedAtOdd == auDetailData.requestedAt}">
              <input type="search" id="focus-requested-at" class="dropdownsearchstyle"
                [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" (onSelectionChange)="onRequestedAtSelect($event, null)"
                [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of requestedAtDropdown | assessmentSearch :requestedAtSearchText"
                (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>

          <div class="col-md-6" *ngIf="auDetailData.requestedAt">
            <div>
              <label id="business-area" for="email">
                {{auDetailData.requestedAtName}}&nbsp;Area
              </label> <span class="mandatory-symbol">*</span>
            </div>
            <mat-select matInput multiple placeholder="Select" #businessArea [(ngModel)]="selectedBusinessArea"
              *ngIf="businessAreaDropdown.length" (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
              (click)="focusSearch('focus-b-area')" (keydown.enter)="focusSearch('focus-b-area')" [disabled]="isFrozen">
              <input type="search" id="focus-b-area" class="dropdownsearchstyle" [(ngModel)]="businessAreaSearchText"
                matInput placeholder="search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected" (change)="toggleAllBusinessArea()">Select
                  All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
            <textarea type="text" class="input-filed-textarea" rows="4" cols="50" *ngIf="!businessAreaDropdown.length"
              [(ngModel)]="auDetailData.coreBusinessAreaName"
              (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
          </div>
        </ng-container>

        <div class="col-md-3">
          <div>
            <label for="email">
              {{dynamicLabel['AUDIT_PROPOSED_DATE'].fieldName}}<span class="mandatory-symbol">*</span>
            </label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_PROPOSED_DATE']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_PROPOSED_DATE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker [disabled]="freezePermanently"
            [bsConfig]="auProposedDateConfig" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="auDetailData.auditProposedDate">
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['SUB_GROUP_NAME'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['SUB_GROUP_NAME']?.fieldNotes"
              [matTooltip]="dynamicLabel['SUB_GROUP_NAME']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" *ngIf="!showSubGroupAsTextBox" [(ngModel)]="selectedSubGroup"
            (closed)="SubGroupTxt=''" (click)="focusSearch('SubGroupSearch')"
            (keydown.enter)="focusSearch('SubGroupSearch')" [disabled]="freezeSubGroupDropDown || freezePermanently"
            [ngClass]="{'odd-item-mat-select':isSubGroupOdd==selectedSubGroup}">
            <input type="search" id="SubGroupSearch" class="dropdownsearchstyle" [(ngModel)]="SubGroupTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of subGroupDropDown| assessmentSearch :SubGroupTxt" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <input class="input-filed-continers" *ngIf="showSubGroupAsTextBox" type="text" [disabled]="freezePermanently"
            [(ngModel)]="auDetailData.subGroupName">
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['LEAD_AUDITOR_USER'].fieldName}}<span
                class="mandatory-symbol">*</span></label>
            <label *ngIf="getSwitchUserPrivilege()" id="owner-validation" for="email"><a
                (click)="openswitchuser('LeadAuditor')"><img title="Switch User"
                  src="..//..//../assets/img/user-switch.png" alt="Switch User Img" width="25" height="25"></a></label>
            <span class="info-icon" *ngIf="dynamicLabel['LEAD_AUDITOR_USER']?.fieldNotes"
              [matTooltip]="dynamicLabel['LEAD_AUDITOR_USER']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedLeadAuditor" (closed)="leadAuditorTxt=''"
            (click)="focusSearch('leadAuditorSearch')" (keydown.enter)="focusSearch('leadAuditorSearch')"
            [ngClass]="{'odd-item-mat-select':isLeadAuditorOdd==selectedLeadAuditor}" [disabled]="freezePermanently">
            <input type="search" id="leadAuditorSearch" class="dropdownsearchstyle" [(ngModel)]="leadAuditorTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of leadAuditorDropDown| assessmentSearch :leadAuditorTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3"
          *ngIf="dynamicLabel['PLANNED_BY_USER']?.isRemovable != 'Y' && dropDownForScheduleApprover.length > 0 && (auDetailData.scheduleBy!=null && auDetailData.scheduleBy!=0)">
          <div>
            <label for="email">{{dynamicLabel['SCHEDULE_APPROVED_BY_USER'].fieldName}}
              <span class="mandatory-symbol">*</span></label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedScheduleApprover" (closed)="leadAuditorTxt=''"
            (click)="focusSearch('schedule-approver-search')" (keydown.enter)="focusSearch('schedule-approver-search')"
            [disabled]="true" [ngClass]="{'odd-item-mat-select':isScheduleApproverOdd==selectedScheduleApprover}">
            <input type="search" id="schedule-approver-search" class="dropdownsearchstyle" [(ngModel)]="leadAuditorTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of scheduleApproverDropDown| assessmentSearch :leadAuditorTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" *ngIf="dynamicLabel['PLANNED_BY_USER']?.isRemovable != 'Y' && auDetailData.plannedByUser">
          <div>
            <label for="email"> {{dynamicLabel['PLANNED_BY_USER'].fieldName}} </label>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="auDetailData.plannedByUser" [disabled]="true">
        </div>

        <div class="col-md-3"
          *ngIf="dynamicLabel['PLAN_APPROVAL_REQUESTED_ON']?.isRemovable != 'Y' && auDetailData.planApprovalRequestedOn">
          <div>
            <label for="email"> {{dynamicLabel['PLAN_APPROVAL_REQUESTED_ON'].fieldName}} </label>
          </div>
          <input class="input-filed-continers" type="text"
            [value]="auDetailData.planApprovalRequestedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
            [disabled]="true">
        </div>

        <div class="col-md-3"
          *ngIf="dynamicLabel['PLAN_APPROVED_ON']?.isRemovable != 'Y' && auDetailData.planApprovedOn">
          <div>
            <label for="email"> {{dynamicLabel['PLAN_APPROVED_ON'].fieldName}} </label>
          </div>
          <input class="input-filed-continers" type="text"
            [value]="auDetailData.planApprovedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
            [disabled]="true">
        </div>

        <div class="col-md-3" *ngIf="dynamicLabel['PLAN_APPROVED_BY_USER']?.isRemovable != 'Y'">
          <div>
            <label for="email">{{dynamicLabel['PLAN_APPROVED_BY_USER'].fieldName}}<span
                class="mandatory-symbol">*</span></label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedPlanApprover" (closed)="planApproverTxt=''"
            (click)="focusSearch('planApproverTxtSearch')" (keydown.enter)="focusSearch('planApproverTxtSearch')"
            [disabled]="true" [ngClass]="{'odd-item-mat-select':isPlanApproverOdd==selectedPlanApprover}">
            <input type="search" id="planApproverTxtSearch" class="dropdownsearchstyle" [(ngModel)]="planApproverTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of planApproverDropDown| assessmentSearch :planApproverTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3"
          *ngIf="dynamicLabel['PLAN_APPROVER_COMMENTS']?.isRemovable != 'Y' && auDetailData.planApproverComments">
          <div>
            <label for="email"> {{dynamicLabel['PLAN_APPROVER_COMMENTS'].fieldName}} </label>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="auDetailData.planApproverComments"
            [disabled]="true">
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['QUESTION_AND_ANSWER_SECTION_TYPE'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['QUESTION_AND_ANSWER_SECTION_TYPE']?.fieldNotes"
              [matTooltip]="dynamicLabel['QUESTION_AND_ANSWER_SECTION_TYPE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="auDetailData.questionAndAnswerSectionType"
            [disabled]="freezePermanently">
            <span class="active-inActive-container" *ngIf="auDetailData.questionAndAnswerSectionType==true"
              [ngStyle]="auDetailData.questionAndAnswerSectionType==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
            <span *ngIf="auDetailData.questionAndAnswerSectionType==false"
              [ngStyle]="auDetailData.questionAndAnswerSectionType==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3">
          <div>
            <label for="email ">{{dynamicLabel['PRIMARY_AUDITEE'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input id="auditee" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [(ngModel)]="participantData.participantName" [disabled]="true">
            </div>
            <div class="col-sm-1" [hidden]="freezePermanently"
              style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="commonDateConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auDetailData.expectedToBeStartedOn" [disabled]="true">
        </div>

        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
          </div>
          <input type=" text" class="form-control data-picker-continer" bsDatepicker
            [dateCustomClasses]="dateCustomClasses" [bsConfig]="commonDateConfig"
            [(ngModel)]="auDetailData.expcetedClosureOn" [disabled]="true">
        </div>

        <div class="col-md-6">
          <div>
            <!-- Short Description -->
            <label for="short-description" id="short-description-validation">
              {{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input id="shortDescription" class="input-filed-continers" type="text"
            (input)="limitCharacters($event, 'SHORT_DESCRIPTION')" autocomplete="off"
            [matTooltip]="auDetailData.shortDescription" [(ngModel)]="auDetailData.shortDescription"
            [disabled]="freezePermanently">
        </div>



        <div class="col-md-6">
          <div class="row">
            <label for="email">{{dynamicLabel['AUDIT_PURPOSE'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_PURPOSE']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_PURPOSE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auDetailData.auditPurpose" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)" [disabled]="true"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="true ? openEditor('Audit Purpose', 'eye') : openEditor('Audit Purpose', 'edit')"
              (keydown.enter)="true ? openEditor('Audit Purpose', 'eye') : openEditor('Audit Purpose', 'edit')">
              <i *ngIf="false" class="far fa-edit"></i>
              <i *ngIf="true" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row">
            <label for="email">{{dynamicLabel['AUDIT_SCOPE'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_SCOPE']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_SCOPE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auDetailData.auditScope" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)" [disabled]="true"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="true ? openEditor('Audit Scope', 'eye') : openEditor('Audit Scope', 'edit')"
              (keydown.enter)="true ? openEditor('Audit Scope', 'eye') : openEditor('Audit Scope', 'edit')">
              <i *ngIf="false" class="far fa-edit"></i>
              <i *ngIf="true" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6" [hidden]="dynamicLabel['AUDIT_REFERENCES']?.isRemovable == 'Y'">
          <div class="row">
            <label for="email">{{dynamicLabel['AUDIT_REFERENCES'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDIT_REFERENCES']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDIT_REFERENCES']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auDetailData.auditReferences" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)" [disabled]="true"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="true ? openEditor('Audit References', 'eye') : openEditor('Audit References', 'edit')"
              (keydown.enter)="true ? openEditor('Audit References', 'eye') : openEditor('Audit References', 'edit')">
              <i *ngIf="false" class="far fa-edit"></i>
              <i *ngIf="true" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6" [hidden]="dynamicLabel['REMARKS']?.isRemovable == 'Y'">
          <div class="row">
            <label for="email">{{dynamicLabel['REMARKS'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['REMARKS']?.fieldNotes"
              [matTooltip]="dynamicLabel['REMARKS']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="auDetailData.remarks" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)" [disabled]="true"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit"
              (click)="true ? openEditor('Remarks', 'eye') : openEditor('Remarks', 'edit')"
              (keydown.enter)="true ? openEditor('Remarks', 'eye') : openEditor('Remarks', 'edit')">
              <i *ngIf="false" class="far fa-edit"></i>
              <i *ngIf="true" class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3" *ngIf="this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y'">
          <div><label for="email">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
              [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="auDetailData.isRiskCalculationReqd"
            [disabled]="isFrozen && auDetailData.status != 'Findings In Progress' && auDetailData.status != 'Auditee Requested More Info.'">
            <span *ngIf="auDetailData.isRiskCalculationReqd==true"
              [ngStyle]="auDetailData.isRiskCalculationReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="auDetailData.isRiskCalculationReqd==false"
              [ngStyle]="auDetailData.isRiskCalculationReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3 d-flex align-items-start"
          *ngIf="this.qualityService.selectedGroupDetailData.isRiskCalculationReqd=='Y' && qualityService.activity.isRiskCalculationReqd && qualityService.activity.finalRiskScore">
          <div class="container">
            <div class="row pt-3">
              <div class="col-sm">
                <span [matTooltip]="'Risk Status : '+qualityService.activity.finalRiskStatus">
                  <img src="../../assets/img/header.png" alt="risk" width="20" height="20" class="ng-star-inserted">
                </span>
              </div>
              <div class="col-sm">
                <span (click)="openRiskSettingTab()" (keydown.enter)="openRiskSettingTab()"
                  [matTooltip]="'Risk Assessment'">
                  <img src="../../assets/img/warning (1).png" alt="risk" width="20" height="20"
                    class="ng-star-inserted">
                </span>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-3" *ngIf="qualityService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
          <div>
            <label for="email">
              {{dynamicLabel['EFFECTIVENESS_CHECK_REQD'] == undefined ?
              'Is Effectiveness Check Required?'
              : dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}
            </label>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="auDetailData.effectivenessCheckReqd" [disabled]="isFrozen">
            <span class="active-inActive-container"
              [ngStyle]="{ color: auDetailData.effectivenessCheckReqd ? 'green' : 'red' }">
              {{ auDetailData.effectivenessCheckReqd ? 'Yes' : 'No' }}
            </span>
          </mat-slide-toggle>
        </div>
      </div>
      <fieldset class="border p-2 crFieldsetStyle">
        <legend class="float-none w-auto p-2">
          <span class="" style="font-size: 14px;color: #cfcfcf;">Audit Conduct Summary</span>
        </legend>

        <div class="row">
          <div class="col-md-2" *ngIf="this.selectedTab != 'Annual Audit Schedule'">
            <div>
              <label for="email">{{dynamicLabel['START_DATE'].fieldName}}</label>
              <span class="mandatory-symbol">*</span>
              <span class="info-icon" *ngIf="dynamicLabel['START_DATE']?.fieldNotes"
                [matTooltip]="dynamicLabel['START_DATE']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="auProposedDateConfig"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auDetailData.startDate" [disabled]="isFrozen"
              (ngModelChange)="onStartedOnChange()">
          </div>

          <div class="col-md-2" *ngIf="this.selectedTab != 'Annual Audit Schedule'">
            <div>
              <label for="email">{{dynamicLabel['END_DATE'].fieldName}}</label>
              <span class="mandatory-symbol">*</span>
            </div>
            <input type=" text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="auEndDateConfig()"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auDetailData.endDate" [disabled]="isFrozen">
          </div>

          <div class="col-md-4">
            <div class="row">
              <label for="email">{{dynamicLabel['LEAD_AUDITOR_COMMENTS'].fieldName}}</label>
              <span class="info-icon" *ngIf="dynamicLabel['LEAD_AUDITOR_COMMENTS']?.fieldNotes"
                [matTooltip]="dynamicLabel['LEAD_AUDITOR_COMMENTS']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-10">
                <st-editor [(ngModel)]="auDetailData.leadAuditorComments" [config]="config" [spellcheck]="true"
                  (paste)="onPaste($event)" [disabled]="isFrozen"></st-editor>
              </div>
              <div class="col-sm-2 angular-editor-edit"
                (click)="isFrozen ? openEditor('Lead Auditor Comments', 'eye') : openEditor('Lead Auditor Comments', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Lead Auditor Comments', 'eye') : openEditor('Lead Auditor Comments', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>

          <div class="col-md-4"
            [hidden]="!qualityService.activity.startedOn || dynamicLabel['AUDIT_OUTCOME_STATUS']?.isRemovable == 'Y'">
            <div>
              <label for="email">{{dynamicLabel['AUDIT_OUTCOME_STATUS'].fieldName}}</label>
              <span class="info-icon" *ngIf="dynamicLabel['AUDIT_OUTCOME_STATUS']?.fieldNotes"
                [matTooltip]="dynamicLabel['AUDIT_OUTCOME_STATUS']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>

            <input class="input-filed-continers" type="text" [(ngModel)]="auDetailData.auditOutcomeStatus"
              [matTooltip]="auDetailData.auditOutcomeStatus" [disabled]="isFrozen">
          </div>
        </div>

        <div class="row mt-3">


          <div class="col-md-4"
            [hidden]="!qualityService.activity.startedOn || dynamicLabel['AUDIT_OVERALL_OUTCOME']?.isRemovable == 'Y'">
            <div class="row">
              <label for="email">{{dynamicLabel['AUDIT_OVERALL_OUTCOME'].fieldName}}</label>
              <span class="info-icon" *ngIf="dynamicLabel['AUDIT_OVERALL_OUTCOME']?.fieldNotes"
                [matTooltip]="dynamicLabel['AUDIT_OVERALL_OUTCOME']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-10">
                <st-editor [(ngModel)]="auDetailData.auditOverallOutcome" [config]="config" [spellcheck]="true"
                  [disabled]="isFrozen" (paste)="onPaste($event)"></st-editor>
              </div>
              <div class="col-sm-2 angular-editor-edit"
                (click)="isFrozen ? openEditor('Audit Overall Outcome', 'eye') : openEditor('Audit Overall Outcome', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Audit Overall Outcome', 'eye') : openEditor('Audit Overall Outcome', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="col-md-4"
            *ngIf="qualityService.activity.startedOn!=null && dynamicLabel['EXECUTIVE_SUMMARY']?.isRemovable != 'Y'">
            <div class="row">
              <label for="email">{{dynamicLabel['EXECUTIVE_SUMMARY'].fieldName}}</label>
              <span class="info-icon" *ngIf="dynamicLabel['EXECUTIVE_SUMMARY']?.fieldNotes"
                [matTooltip]="dynamicLabel['EXECUTIVE_SUMMARY']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-10">
                <st-editor [(ngModel)]="auDetailData.executiveSummary" [config]="config" [spellcheck]="true"
                  [disabled]="isFrozen" (paste)="onPaste($event)"></st-editor>
              </div>
              <div class="col-sm-2 angular-editor-edit"
                (click)="isFrozen ? openEditor('Executive Summary', 'eye') : openEditor('Executive Summary', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Executive Summary', 'eye') : openEditor('Executive Summary', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="col-md-4"
            [hidden]="!qualityService.activity.startedOn || dynamicLabel['CONCLUSION']?.isRemovable == 'Y'">
            <div class="row">
              <label for="email">{{dynamicLabel['CONCLUSION'].fieldName}}</label>
              <span class="info-icon" *ngIf="dynamicLabel['CONCLUSION']?.fieldNotes"
                [matTooltip]="dynamicLabel['CONCLUSION']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <div class="row">
              <div class="hideToolbar col-sm-10">
                <st-editor [(ngModel)]="auDetailData.conclusion" [config]="config" [spellcheck]="true"
                  [disabled]="isFrozen" (paste)="onPaste($event)"></st-editor>
              </div>
              <div class="col-sm-2 angular-editor-edit"
                (click)="isFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')"
                (keydown.enter)="isFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')">
                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="border p-2 crFieldsetStyle">
        <legend class="float-none w-auto p-2">
          <span class="" style="font-size: 14px;color: #cfcfcf;">More Info</span>
        </legend>
        <div class="row field-styles1" style="margin-top: -1%;">
          <div class="col-md-2" *ngIf="auDetailData.lastActionOn">
            <div>
              <label for="email">
                {{dynamicLabel['LAST_ACTION_ON']?.fieldName}}
              </label>
            </div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="auDetailData.lastActionOn" [disabled]="true">
          </div>
          <div class="col-md-2" *ngIf="auDetailData.lastActionByUser">
            <div>
              <label for="email">
                {{dynamicLabel['LAST_ACTION_BY_USER']?.fieldName}}
              </label>
            </div>
            <input type="text" class="input-filed-continers" [(ngModel)]="auDetailData.lastActionByUser"
              [disabled]="true">
          </div>
          <div class="col-md-2" *ngIf="auDetailData.lastActionComments">
            <div>
              <label for="email">
                {{dynamicLabel['LAST_ACTION_COMMENTS']?.fieldName}}
              </label>
            </div>
            <input type="text" class="input-filed-continers" [(ngModel)]="auDetailData.lastActionComments"
              [disabled]="true">
          </div>
          <div class="col-md-2" *ngIf="auDetailData.peerReviewCompletedOn">
            <div>
              <label for="email">{{dynamicLabel['PEER_REVIEW_COMPLETED_ON'].fieldName}}</label>
            </div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker
              [dateCustomClasses]="dateCustomClasses" [bsConfig]="dateTimeConfig"
              [(ngModel)]="auDetailData.peerReviewCompletedOn" [disabled]="true">
          </div>
        </div>
      </fieldset>
      <div class="ActivityPage" id="Additionaldetail" style="margin-top: 15px;">
        <app-flexible-fields #flexible [from]="'Details'"></app-flexible-fields>
      </div>

    </div>
  </mat-tab>
  <div *ngFor="let tabPage of message.tabPagesOrderlist; let idx = index;">
    <mat-tab label="Workflow" *ngIf="parallelWorkflowList.length>0 && tabPage=='Parallel Workflow'">
      <ng-template mat-tab-label>
        <span>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
              fill="#0F3659" stroke="#0F3659" [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
          </svg> </span>&nbsp;
        <span>Parallel Workflow</span>
      </ng-template>
      <div class="form-template ActivityPage" id="Workflow" style="margin-top:1%;">
        <app-parallel-workflow *ngIf="selectedTabName === 'Workflow'" [showGrid]="true"></app-parallel-workflow>
      </div>
    </mat-tab>
    <mat-tab label="Questionnaire" *ngIf="showQuestionAndAnswerSectionType  && tabPage=='Questionnaire'">
      <ng-template mat-tab-label>
        <span><i class='fa fa-question' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Questionnaire</span>
      </ng-template>
      <app-au-questions *ngIf="selectedTabName === 'Questionnaire'"></app-au-questions>
    </mat-tab>

    <mat-tab label="Participants" *ngIf=" tabPage=='Participants'">
      <ng-template mat-tab-label>
        <span><i class='fas fa-users' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Participants</span>
      </ng-template>
      <app-au-participants *ngIf="selectedTabName === 'Participants'"
        (refreshed)="onParticipantRefresh($event)"></app-au-participants>
    </mat-tab>

    <mat-tab label="Findings" *ngIf="tabPage=='Findings'">
      <ng-template mat-tab-label>
        <span><i class='fa fa-search' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Findings</span>
      </ng-template>
      <app-au-findings *ngIf="selectedTabName === 'Findings'"></app-au-findings>
    </mat-tab>

    <mat-tab label="Followups" *ngIf="tabPage=='Followups'">
      <ng-template mat-tab-label>
        <span><i class='fa fa-arrow-up' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Followups</span>
      </ng-template>
      <app-au-followups [activityData]="true" *ngIf="selectedTabName === 'Followups'"></app-au-followups>
    </mat-tab>

    <mat-tab label="Recommendations" *ngIf="tabPage=='Recommendations'">
      <ng-template mat-tab-label>
        <span><i class='fa fa-question-circle' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Recommendations</span>
      </ng-template>
      <app-au-recommendations *ngIf="selectedTabName === 'Recommendations'"></app-au-recommendations>
    </mat-tab>

    <mat-tab label="Documents" *ngIf="tabPage=='Files'">
      <ng-template mat-tab-label>
        <span><i class='fa-regular fa-file' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Files</span>
      </ng-template>
      <div class="form-template ActivityPage" id="Documents" style="margin-top:1%;">
        <app-task-documents *ngIf="selectedTabName=='Documents'" [activity]="this.objForDocuments"></app-task-documents>
      </div>
    </mat-tab>

    <mat-tab label="Reviewer/Approver" *ngIf="!isStageUsersSkipped && tabPage=='Reviewer/Approver'">
      <ng-template mat-tab-label>
        <span><i class='fa-solid fa-file-circle-check' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Reviewer/Approver</span>
      </ng-template>
      <div class="form-template ActivityPage" id="ReviewApprove" style="margin-top:1%;">
        <app-stageusers *ngIf="selectedTabName === 'Reviewer/Approver'" (valueChange)="on_stageUser_emit($event)"
          [activityData]="this.qualityService.activity"></app-stageusers>
      </div>
    </mat-tab>

    <mat-tab label="Extension" *ngIf="tabPage=='Extension'">
      <ng-template mat-tab-label>
        <span><i class='fa-regular fa-file-code' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Extension</span>
      </ng-template>
      <div class="form-template ActivityPage" id="Extendsion" style="margin-top:1%;">
        <app-task-extensions *ngIf="selectedTabName === 'Extension'" (extension)="on_extension_emit($event)"
          [activityData]="true"></app-task-extensions>
      </div>
    </mat-tab>

    <mat-tab label="Dependency" *ngIf="tabPage=='Dependency'">
      <ng-template mat-tab-label>
        <span><i class='fa-solid fa-layer-group' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;
        <span>Dependency</span>
      </ng-template>
      <div class="form-template ActivityPage" id="Dependency" style="margin-top:1%;">
        <app-quality-dependencies *ngIf="selectedTabName === 'Dependency'"></app-quality-dependencies>
      </div>
    </mat-tab>

    <mat-tab label="Risk Assessment"
      *ngIf="qualityService.activity.isRiskCalculationReqd && qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y' && tabPage=='Risk Assessment'">
      <ng-template mat-tab-label>
        <span>
          <img src="../../assets/img/warning (1).png" alt="tasks" width="20" height="20" class="ng-star-inserted">
        </span>&nbsp;
        <span>Risk Assessment</span>
      </ng-template>
      <div class="form-template ActivityPage" id="Risk Assessment" style="margin-top:1%;">
        <app-risk [pagename]="'activity'" *ngIf="selectedTabName === 'Risk Assessment'"></app-risk>
      </div>
    </mat-tab>

    <mat-tab label="Effectiveness Check" *ngIf="message.showEffectiveSection  && tabPage=='Effectiveness Check'">
      <ng-template mat-tab-label>
        <span>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.7 7.19981L7.67277 10.7998L6.3 9.57266M16.2 4.4998L16.2 13.4999C16.2 14.9911 14.9912 16.1999 13.5 16.1999H4.5C3.00883 16.1999 1.8 14.9911 1.8 13.4999V4.4998C1.8 3.00864 3.00883 1.7998 4.5 1.7998H13.5C14.9912 1.7998 16.2 3.00864 16.2 4.4998Z"
              stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
              [ngStyle]="{strokeWidth: selectedTab == 'Effectiveness Check' ? '2' : ''}" />
          </svg>
        </span>&nbsp;
        <span>Effectiveness Check</span>
      </ng-template>
      <div class="form-template ActivityPage" id="Effectiveness Check" style="margin-top:1%;">
        <app-tasks-ec (valueChange)="on_effectiveness_emit($event)" *ngIf="selectedTabName === 'Effectiveness Check'"
          [activityData]="true"></app-tasks-ec>
      </div>
    </mat-tab>

    <mat-tab label="Notifications" *ngIf="tabPage=='Notifications' && isAdditionalTabUser">
      <ng-template mat-tab-label>
        <span><i class="fa-solid fa-bell" style="font-size: 18px;"></i></span>&nbsp;
        <span>Notifications</span>
      </ng-template>
      <div class="form-template ActivityPage" style="margin-top:1%;">
        <app-activity-notifications *ngIf="selectedTabName === 'Notifications'"></app-activity-notifications>
      </div>
    </mat-tab>

    <mat-tab label="History" *ngIf="tabPage=='History' && isAdditionalTabUser">
      <ng-template mat-tab-label>
        <span><i class="fa-solid fa-clock-rotate-left" style="font-size: 18px;"></i></span>&nbsp;
        <span>History</span>
      </ng-template>
      <div class="form-template ActivityPage" style="margin-top:1%;">
        <app-task-history *ngIf="selectedTabName === 'History'"></app-task-history>
      </div>
    </mat-tab>
  </div>
</mat-tab-group>

<ng-template #vendorPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelVendorPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search Vendor </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Vendor Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByVendorName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Vendor Code</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByVendorCode">
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchVendorFunc()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetVendorFunc()">
          <i class="fa fa-repeat"></i> Reset
        </button>
        <button *ngIf="!showVendorGrid" mat-stroked-button class="cancelButton" (click)="cancelVendorPopup()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>

    <div class="no-result-found" *ngIf="noResultFound">
      No Result Found
    </div>

    <div class="table-container" *ngIf="showVendorGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th>
          <span>Vendor Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Vendor Code</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Services Offered</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Year Established</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Email Address</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th id="menu" class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="let vendor of vendorList; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="vendor.vendorChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="vendor.vendorChildCheckBoxs"
                  (change)="vendorGridCheckBox($event, vendor, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ vendor.vendorName }}</td>
          <td class="row-data">{{ vendor.vendorCode }}</td>
          <td class="row-data">{{ vendor.servicesOffered }}</td>
          <td class="row-data">{{ vendor.yearEstablished }}</td>
          <td class="row-data">{{ vendor.emailAddress }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showVendorGrid">
    <button mat-stroked-button class="addButton" (click)="selectVendor()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelVendorPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #departmentPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelDepartmentPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search Department </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Code List Group Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByGroupName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Code List Name(Department Name)</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByCodeListName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Code List Code(Department Code)</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByCodeListCode">
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchDepartmentFunc()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetDepartmentFunc()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>

    <div class="no-result-found" *ngIf="noResultFound">
      No Result Found
    </div>

    <div class="table-container" *ngIf="showDepartmentGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th>
          <span>Code List Group Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Code List Code</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Code List Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Sub Group Name</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th>
          <span>Sub Group Values</span>
          <span class="fa-solid fa-filter multi-filter-container"></span>
        </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="let department of departmentList; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="department.departmentChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="department.departmentChildCheckBoxs"
                  (change)="departmentGridCheckBox($event, department, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ department.codelistsPk.groupName }}</td>
          <td class="row-data">{{ department.codelistsPk.codelistCode }}</td>
          <td class="row-data">{{ department.codelistName }}</td>
          <td class="row-data">{{ department.subgroupName }}</td>
          <td class="row-data">{{ department.subgroupValues }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showDepartmentGrid">
    <button mat-stroked-button class="addButton" (click)="selectDepartment()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelDepartmentPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #participantPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelParticipantSelect()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Participant </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-container">
    <div class="row">
      <div class="col-md-3" *ngIf="!isprimaryauditee">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3" *ngIf="!isprimaryauditee">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3" *ngIf="!isprimaryauditee">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3" *ngIf="!isprimaryauditee">
        <div><label for="email">Email Address</label></div>
        <input class="input-filed-continers" type="email" [(ngModel)]="searchByemailAddress">
      </div>
      <div class="col-md-3" *ngIf="!isprimaryauditee">
        <div><label for="email">Designation</label></div>
        <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="searchByDesignationCode"
          [settings]="singleSelectDropdownSetting" [data]="designationCodeDropdown">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-md-3" *ngIf="!isprimaryauditee">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentCodeSearchTxt=''" (click)="focusSearch('departmentCodeSearch')"
          (keydown.enter)="focusSearch('departmentCodeSearch')">
          <input type="search" id="departmentCodeSearch" class="dropdownsearchstyle"
            [(ngModel)]="departmentCodeSearchTxt" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :departmentCodeSearchTxt"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <div><label for="email">Is Primary Auditee</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="isprimaryauditee" (change)="toggle($event)">
          <ng-container *ngIf="isprimaryauditee; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row" *ngIf="!isprimaryauditee">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchParticipant()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetParticipant()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="participantListForGrid.length && !isprimaryauditee">
      <table class="search-participant-table-container" style="height: 45vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
              </div>
            </div>
          </th>
          <th> <span>User Name</span></th>
          <th> <span>First Name</span></th>
          <th> <span>Last Name</span></th>
          <th> <span>User Full Name</span></th>
          <th> <span>Designation</span></th>
          <th> <span>Department</span></th>
          <th> <span>EmailAddress</span></th>
          <th> <span>Contact Number</span></th>
          <th> <span>Manager Name</span></th>
          <th> <span>Is Ad User</span></th>
          <th> <span>Is Factory User</span></th>
          <th> <span>Is Active</span></th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let participant of participantListForGrid; let idx = index;"
            [class.highlightRow]="participant.participantChildCheckBox">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="participant.participantChildCheckBox ? 'static_icon' : 'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input type="checkbox" style="zoom: 1.2;" [checked]="participant.participantChildCheckBox"
                    (change)="participantChildCheckBoxChecked($event, participant, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ participant.userName }}</td>
            <td class="row-data">{{ participant.firstName }}</td>
            <td class="row-data">{{ participant.lastName }}</td>
            <td class="row-data">{{ participant.userFullName }}</td>
            <td class="row-data">{{ participant.designation }}</td>
            <td class="row-data">{{ participant.department }}</td>
            <td class="row-data">{{ participant.emailAddress }}</td>
            <td class="row-data">{{ participant.contactNumber }}</td>
            <td class="row-data">{{ participant.managerName }}</td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="participant.isAdUser">
            </td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="participant.isFactoryUser"> </td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="participant.isActive">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="isprimaryauditee">
      <div class="table-container">
        <table class="search-participant-table-container" aria-describedby="table-description" style="height: 45vh;">
          <thead>
            <th style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div>
                  <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;"></div>
              </div>
            </th>
            <th> <span>User Name</span></th>
            <th> <span>First Name</span></th>
            <th> <span>Last Name</span></th>
            <th> <span>User Full Name</span></th>
            <th> <span>Designation</span></th>
            <th> <span>Department</span></th>
            <th> <span>EmailAddress</span></th>
            <th class="sticky-col first-col"></th>
          </thead>
          <tbody>
            <tr class="data-row-container" *ngFor="let participant of primaryauditeeList; let idx = index;"
              [class.highlightRow]="participant.participantChildCheckBox">
              <td style="min-width: 80px; text-align: center;">
                <div style="display: flex;">
                  <div [ngClass]="participant.participantChildCheckBox ? 'static_icon' : 'hover-menu-icons'">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px;">
                    <input type="checkbox" style="zoom: 1.2;" [checked]="participant.participantChildCheckBox"
                      (change)="participantChildCheckBoxChecked($event, participant, idx)">
                  </div>
                </div>
              </td>
              <td class="row-data">{{ participant.userName }}</td>
              <td class="row-data">{{ participant.firstName }}</td>
              <td class="row-data">{{ participant.lastName }}</td>
              <td class="row-data">{{ participant.userFullName }}</td>
              <td class="row-data">{{ participant.designation }}</td>
              <td class="row-data">{{ participant.department }}</td>
              <td class="row-data">{{ participant.emailAddress }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions *ngIf="getApplicationUserId || isprimaryauditee">
      <button mat-stroked-button class="addButton" (click)="selectParticipant()" [disabled]="!getApplicationUserId">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelParticipantSelect()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? config1 : config" [spellcheck]="true"
        (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>


<!-- PDF Report Popup-->
<ng-template #openExportReportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Choose Report Template </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer1">
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="reportTemplate-validation" for="email">Report Template</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportTemplateValue"
          (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-group-search')"
          (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onPdfDetailValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportTemplateDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onPdfDetailValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Report Logo</label>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
          (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-footer-search')" (keydown.enter)="focusSearch('focus-footer-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Attach all documents?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="attachAllDocuments">
          <ng-container *ngIf="attachAllDocuments; else noattachAllDocuments">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noattachAllDocuments>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="attachAllDocuments">

      <label for="email">Attachments to the report are limited to PDF, DOC, or DOCX formats.</label>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="exportReportGenerateFuntion()">
      <i class="fas fa-check"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="exportReportCancelPopupFuntion()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #reasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeReasonPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Reason for Switch </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px;" class="col-md-11">
    <div>
      <label id="switch-reason-validation" for="email">Reason
        <span class="mandatory-symbol">*</span>
      </label>
    </div>
    <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="reasonForSwitch"
      (ngModelChange)="mandatoryValidation($event,'switch-reason-validation')"></textarea>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
    <button mat-stroked-button class="addButton" (click)="openConfirmationPopup()">
      <i class="fa fa-check"></i> Yes
    </button>
    <button mat-stroked-button class="cancelButton" (click)="closeReasonPopup()">
      <i class="fas fa-close"></i> No
    </button>
  </div>
</ng-template>

<ng-template #switchConfirmationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeSwitchConfirmationPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Confirmation </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="center">
    <label for="email" style="font-size: medium; font-weight: bold;">
      Do you want to Switch Primary Auditee?</label>
  </div>

  <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
    <button mat-stroked-button class="addButton" (click)="executeUserSwitch()">
      <i class="fa fa-check"></i> Yes
    </button>
    <button mat-stroked-button class="cancelButton" (click)="closeSwitchConfirmationPopup()">
      <i class="fas fa-close"></i> No
    </button>
  </div>
</ng-template>

<app-top-navigation [hidden]="true"></app-top-navigation>


<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" mat-button (click)="canceltopicPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{qualityService.moduleFullName}}&nbsp;Topics </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-add-parallel-workflows (valueEmitter)="onworkflowChildValueEmitted()"
  *ngIf="addworkflow"></app-add-parallel-workflows>
<app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>

<app-moduletype (valueEmitter)="onModuleTypeEmitted($event)" [parentData]="moduleTypeData"></app-moduletype>
<app-quality-dependents></app-quality-dependents>
